export default __webpack_public_path__ + "static/media/mp_wellcome_icon.95125644.svg";